import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWebflow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconWebflow"><Path fillRule="evenodd" clipRule="evenodd" d="M24 4.82648L16.661 19.1735H9.76761L12.839 13.2274H12.7012C10.1673 16.5167 6.38674 18.6821 1 19.1735V13.3098C1 13.3098 4.44603 13.1062 6.47185 10.9764H1V4.82659H7.14977V9.88469L7.2878 9.88412L9.80085 4.82659H14.4518V9.85261L14.5897 9.85239L17.1971 4.82648H24Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWebflow;
